<template>
  <div>
    <a-card class="py-5 mt-5" v-if="rows">
      <div class="container mx-auto text-center">
        <img src="../../../public/task.svg" />
        <h2>You haven't created any calendar events.</h2>
        <p class="text-base font-medium">
          Go to the Calendar menu to create some events.
        </p>
      </div>
    </a-card>

    <vx-card v-else no-shadow class="mt-5 overflow-auto">
      <div class="flex justify-between">
        <h1 class="text-2xl font-semibold">Calendar Events</h1>
      </div>
      <a-divider/>
      <div class="flex justify-between">
        <div class="flex items-center gap-2">
          <ChipCustomizeCloseClearChipIcon
            v-if="$refs.events"
            :items="$route.params.id || filterStorage.length ? [] : $refs.events.query.query"
            :data="{
              responsible  : $refs.users        ? $refs.users.data        : [],
              groups       : $refs.permissions  ? $refs.permissions.data  : [],
              contacts     : $refs.listContacts ? $refs.listContacts.rows : [],
            }"
            @deleteFilter="deleteFilter"
          />
          <a-button
            type="primary"
            ghost
            icon="filter"
            @click="showDrawer"
            style="border-radius: 3px !important;"
          >
            <template #icon>
              <feather-icon icon="FilterIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
            </template>
            Filters
          </a-button>
        </div>
        <a-button type="primary" @click="openCreateEventModal">New Event</a-button>
      </div>

      <XTable
        :model="model"
        ref="events"
        :options="options"
        @refresh="refresh"
        class="overflow-auto mt-10"
      >
        <span slot="title" slot-scope="text,record">
          <a-popover v-if="text.record && text.record.title">
            <template slot="content">
              <p>{{ text.record.title }}</p>
            </template>
            <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 25rem; text-align: left;">
              {{ text.record.title }}
            </p>
          </a-popover>
        </span>
        <span slot="creator" slot-scope="text,record">
          <span>{{ text.record.creator.first_name }} {{ text.record.creator.last_name }}</span>
        </span>
        <span slot="is_all_day" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_all_day"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
        <span slot="is_for_firm" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_for_firm"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
        <span slot="labels" slot-scope="text,record">
            <a-tag v-if="text.record.labels == 1" color="blue">Normal</a-tag>
            <a-tag v-else-if="text.record.labels == 2" color="green">Low</a-tag>
            <a-tag v-else-if="text.record.labels == 3" color="yellow">High</a-tag>
            <a-tag v-else-if="text.record.labels == 4" color="red">Urgent</a-tag>
        </span>
        <span slot="start" slot-scope="text,record">
          <span style="white-space: nowrap;">{{ setDateFormat(text.record.start) }}</span>
        </span>
        <span slot="end" slot-scope="text,record">
          <span style="white-space: nowrap;">{{ setDateFormat(text.record.end) }}</span>
        </span>
        <span slot="description" slot-scope="text,record">
          <a-popover v-if="text.record.description">
            <template slot="content">
              <p>{{ text.record.description }}</p>
            </template>
            <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 15rem; text-align: left;">
              {{ text.record.description }}
            </p>
          </a-popover>
        </span>
        <span slot="attendees" slot-scope="text,record">
          <span v-if="!text.record.for_users || text.record.for_users.length === 0"></span>
          <span v-else-if="text.record.for_users.length === 1">
            {{ text.record.for_users[0].first_name }} {{ text.record.for_users[0].last_name }}
          </span>
          <a-popover v-else trigger="click" placement="bottom">
            <template slot="content">
                <template v-if="text.record.for_users.length">
                <ATag v-for="(attendee,i) in text.record.for_users" :key="i">
                  {{ attendee.first_name }}  {{ attendee.last_name }}
                </ATag>
                </template>
              <template v-else>No attendee</template>
            </template>
            <span>
              {{ text.record.for_users[0].first_name }} {{ text.record.for_users[0].last_name }},
              <a-button type="link" class="pl-0" @click="is_click_add_time = false">more</a-button>
            </span>
          </a-popover>
        </span>
        <span slot="tags" slot-scope="text,record">
          <span v-if="!text.record.tags || getTags(text.record.tags).length === 0"></span>
          <span v-else-if="getTags(text.record.tags).length === 1">
            {{ getTags(text.record.tags)[0] }}
          </span>
          <a-popover v-else trigger="click" placement="bottom">
            <template slot="content">
                <template v-if="getTags(text.record.tags).length">
                <a-tag v-for="(tag, i) in getTags(text.record.tags)" :key="i">
                  {{ tag }}
                </a-tag>
                </template>
              <template v-else>No tag</template>
            </template>
            <span>
              {{ getTags(text.record.tags)[0] }}
              <a-button type="link" class="pl-0" @click="is_click_add_time = false">more</a-button>
            </span>
          </a-popover>
        </span>
        <span slot="matter" slot-scope="text,record">
          <a-popover v-if="text.record && text.record.matter">
            <template slot="content">
              <p>{{ text.record.matter.title }}</p>
            </template>
            <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 15rem; text-align: left;">
              {{ text.record.matter.title }}
            </p>
          </a-popover>
        </span>
        <span slot="action" slot-scope="text,record" class="flex space-x-3">
          <a-dropdown>
            <a-menu slot="overlay">
              <!-- v-if="hasPermission('matter.get')" -->
              <a-menu-item key="1" @click="openEditEventModal(text.record.id)"><feather-icon icon="EditIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Edit</a-menu-item>
              <a-menu-item key="2" @click="promptDelete(text.record.id)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px" @click="is_click_add_time = false">
              Actions <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </XTable>
    </vx-card>

    <Drawer
      ref="drawer"
      :form="form"
      :ele="$refs.events"
      :query="[
        { field : 'start', value: form.getFieldValue('start') , condition: '>='},
        { field : 'end', value: form.getFieldValue('end') , condition: '<='},
        { field : 'title', value: form.getFieldValue('title') , condition: 'like'},
        { field : 'matter__id', value: form.getFieldValue('matter') , condition: 'like'},
        { field : 'labels', value: form.getFieldValue('labels') , condition: 'like'},
        { field : 'location', value: form.getFieldValue('location') , condition: 'like' },
        { field : 'for_users', value: form.getFieldValue('for_users') , condition: 'in' },

        // { field : 'creator__first_name', value: form.getFieldValue('first_name') , condition: 'like'},
        // { field : 'creator__last_name', value: form.getFieldValue('last_name') , condition: 'like'},

        // { field : 'client', value: form.getFieldValue('client') , condition: '=' },
        // { field : 'responsible', value: form.getFieldValue('responsible') , condition: 'in' },
        // { field : 'origination', value: form.getFieldValue('origination') , condition: 'in' },
      ]"
    >
      <a-form-item label="Start Date" has-feedback>
        <a-date-picker
          v-decorator="['start', { rules: [
              { required: false },
              {
                validator: (rule,value) => validateCheckDateFrom(value, 'end'),
                required: true, message: 'The start date must be smaller than the end date.\n'
              }
            ]}]"
          class="w-full"
          placeholder="dd/mm/yyyy"
          :format="dateFormat"
          valueFormat="YYYY-MM-DD"
        />
      </a-form-item>
      <a-form-item label="End Date" has-feedback>
        <a-date-picker
          v-decorator="[
              'end',
              {
                rules: [
                  { required: false },
                  { validator: (rule,value) => validateCheckDateTo(value, 'start'), required: true , message: 'The end date must be greater than the start date.\n' }
                ]
              }
            ]"
          class="w-full"
          placeholder="dd/mm/yyyy"
          :format="dateFormat"
          valueFormat="YYYY-MM-DD"
        />
      </a-form-item>
      <a-form-item label="Title" has-feedback>
        <input
          v-decorator="['title', { rules: [{ required: false }] }]"
          placeholder="Title..."
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item>
      <!-- <a-form-item label="Matter" has-feedback>
        <input
          v-decorator="['matter', { rules: [{ required: false }] }]"
          placeholder="Matter..."
          autocomplete="none"
          class="ant-input"
        />
      </a-form-item> -->
      <a-form-item label="Label" has-feedback>
        <a-select v-decorator="['labels', { initialValue: undefined, rules: [{ required: false }] }]">
          <a-select-option v-for="(label, index) in calendarLabels" :value="label.value">
            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
            <span>{{ label.text }}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Location" has-feedback>
        <input
          v-decorator="['location',{ rules: [{ required: false }] }]"
          placeholder="Location"
          class="ant-input"
          autocomplete="none"
        />
      </a-form-item>
      <SelectOption
        url="/account/list/"
        label="Attendees"
        field="for_users"
        method="get"
        mode="multiple"
        placeholder="Find A User"
        class="w-full"
      />
      <!-- <SelectOption ref="users" url="/account/list/" label="Responsible Lawyer" placeholder="Responsible" field="responsible" method="get" mode="multiple"/> -->
      <!-- <SelectOption ref="users" url="/account/list/" label="Originating Lawyer" placeholder="Originating" field="origination" method="get" mode="multiple"/> -->
      <!-- <a-form-item label="Creator" has-feedback>
        <input
          v-decorator="['first_name', { rules: [{ required: false }] }]"
          placeholder="First Name..."
          autocomplete="none"
          class="ant-input"
        />
        <input
          v-decorator="['last_name', { rules: [{ required: false }] }]"
          placeholder="Last Name..."
          autocomplete="none"
          class="ant-input mt-4"
        />
      </a-form-item> -->

      <selectSearch
        :required="false"
        url="/matter/query/"
        :options="optionSearchMatter"
        class="self-center mt-8 md:mt-0 w-full"
        :is_include_matter="true"
        @selectSearch="handleSearch"
      />
      <!-- <selectSearch
        ref="listContacts"
        :options="{placeholder: 'Search contacts',label: 'Client',field: 'client',width: '100%',allow_clear: true}"
      /> -->
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 1,
        }"
      >
        <div class="flex gap-2">
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important">
            Save Filters
          </a-button>
        </div>
      </div>
    </Drawer>

    <CalendarEventForm
      v-model="showEventForm"
      :edit_mode="edit_mode"
      :event_id="eventId"
      @success="onEventUpdatedSuccessfully"
    />

    <vs-prompt
      color="danger"
      title="Delete Event"
      @cancel="active_prompt = false"
      @close="active_prompt = false"
      :active.sync="active_prompt"
      buttons-hidden
    >
      <div class="text-left">
        <div class="font-medium">Are you sure to delete this calendar event?</div>
      </div>
      <div class="flex justify-center space-x-3 mt-5">
        <vs-button color="danger" @click="deleteItem">Delete</vs-button>
        <vs-button color="danger" type="flat" @click="active_prompt = false">Cancel</vs-button>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableCol from './eventsTbl'
import axios from "@/axios"
import SelectSearch from '../forms/selectSearch'
import SelectOption from '../forms/SelectOptionSingle'
import Timer from "@/layouts/components/timer/Timer";
import Mixin from '../mixin/mixin'
import Drawer from '../drawer/Drawer'
import VueHtml2pdf from 'vue-html2pdf'
import ChipCustomizeCloseClearChipIcon from "@/views/components/vuesax/chip/ChipCustomizeCloseClearChipIcon";
import CalendarEventForm from './EventForm.vue'

export default {
  name: "CalendarEvents",

  mixins: [Mixin],

  props: {
    activeFilter: {
      type: Boolean,
      default: false
    },
    hasFilterContact: {
      type: Boolean,
      default: false
    }
  },

  components: {
    XTable,
    SelectSearch,
    SelectOption,
    Drawer,
    Timer,
    VueHtml2pdf,
    ChipCustomizeCloseClearChipIcon,
    CalendarEventForm,
  },

  data() {
    return{
      model                   : null,
      active_prompt           : false,
      current_id              : null,
      loading                 : false,
      options                 : {
        placeholder:'Search events...',
        noContent: 'No calendar events.',
        is_row_selection: false,
        is_load_req: false
      },
      order_matter_client_items: [],
      showEventForm: false,
      edit_mode: false,
      eventId: 0, // The ID of the calendar event to edit, when in edit mode.
      calendarLabels     : [
        { value: undefined, text: 'All',    color: 'secondary' },
        { value: 4,         text: 'Urgent', color: 'danger'  },
        { value: 3,         text: 'High',   color: 'warning' },
        { value: 1,         text: 'Normal', color: 'primary' },
        { value: 2,         text: 'Low',    color: 'success' },
      ],
    }
  },

  methods:{
    async deleteFilter(item){
      try {
        await this.$refs.events.fetch()
        this.form.resetFields(item.field.includes('__') ? item.field.split('__')[1] : item.field )
      }catch (e) {
        throw new Error(e)
      }
    },

    statusMatter(sts){
      if(sts === 1)
        return {title:'Open',color:'green'}
      else if(sts === 2)
        return {title:'Close',color: 'red'}
      else if(sts === 3)
        return {title:'Pending',color:'yellow'}
    },

    // this.$nextTick(()=>this.form.setFieldsValue({ matter: id }))

    async handleMatterClientReport(){
      try{
        const { data } = await axios.get('/report/stats/matter/index')
        this.order_matter_client_items = data.result
        this.$nextTick(()=>this.order_matter_client_items = data.result.map((item,ind)=>this.$refs['matters_client'][ind].data = item))
      }catch (e) {
        this.$message.error('Server error')
      }
    },

    matterDashboard(record){
      this.is_click_add_time = false
      this.$router.push(`/matters/dashboard/${record.id}`)
      this.$store.commit('DASHBOARD_ID',record.id)
    },

    refresh(){
      // @NotImplemented
      // this is supposed to refresh the table, re-fetching the data again.
    },

    showDrawer(){
      this.$refs.drawer.visible_drawer = true
    },

    // async filterStatus(sts){
    //     this.checkPagenation(this.$refs.events)
    //     sts === 'all' ?  this.$refs.events.query.query = [...this.filterStorage] : this.$refs.events.query.query = [...this.filterStorage,{ field: 'status',condition: '=',value: sts }]
    //     await this.$refs.events.fetch()
    // },

    promptDelete(id) {
      this.current_id = id
      this.active_prompt = true
    },

    async deleteItem(){
      try {
        this.$refs.events.loading = true
        this.active_prompt = false
        await axios.delete(`/calendar/event/${this.current_id}/`)
        await this.$refs.events.fetch()
        this.$notification['success']({
          message: 'Success',
          description: `Calender event deleted.`,
        })
        this.current_id = null
      } catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: `Failed to delete the calenadr event. Please try again.`,
        })
      } finally {
        this.$refs.events.loading = false
      }
    },

    /**
     * Converts A JSON containing an array of strings into an Array object of
     * strings.
     *
     * @param {String} tags A JSON string that contains an array of strings.
     */
    getTags(tags) {
      let tmp = tags.replace(/'/mg, "\"")
      tmp = JSON.parse(tmp)
      return tmp
    },

    openCreateEventModal() {
      this.edit_mode = false
      this.showEventForm = true
    },

    openEditEventModal(id) {
      this.edit_mode = true
      this.eventId = id
      this.showEventForm = true
    },

    onEventUpdatedSuccessfully() {
      this.$refs.events.fetch()
    },
  },
  computed:{
    rows() {
      if (this.$refs.events) {
        return this.$refs.events.query
      }
    },
    filterStorage() {
      const user = JSON.parse(localStorage.getItem('user'))
      return [
        { field: 'responsible' , condition: '=' , value: user.id , operation:'or' },
        { field: 'origination' , condition: '=' , value: user.id , operation:'or' },
        { field: 'origination' , condition: '=' , value: null , operation:'or' },
        { field: 'responsible' , condition: '=' , value: null , operation:'or' },
      ]
    },
  },
  async mounted() {
    this.is_click_add_time = true
    this.handleMatterClientReport()
    if (this.$route.params.query) {
      this.$refs.events.onSearch(this.$route.params.query)
    }
    else if (localStorage.getItem('user')) {
      // this.$refs.events.query.query = this.filterStorage
      if (this.hasFilterContact) {
        this.$refs.events.query.query = [...this.$refs.events.query.query,{ field: 'client__id', condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
      }
      await this.$refs.events.fetch()
    }
  },
  created() {
    this.model = TableCol.default
  },
}
</script>

<style>
@import "../style/style.css";
[dir=ltr] .ant-modal-footer{
  display: none;
}
.matter-add{
  text-align: right;
  display: block;
  margin-left: auto;
}
[dir=ltr] .ant-radio-button-wrapper:first-child{
  border-radius: 3px 0 0 3px;
}
[dir=ltr] .ant-radio-button-wrapper:last-child{
  border-radius: 0 3px 3px 0;
}
[dir] .ant-card-bordered{
  border-radius: 6px;
}
[dir] .ant-input, [dir] .ant-calendar-picker-input, [dir] .ant-select-selection {
  border-radius: 3px !important;
}
.ant-calendar-picker-input,.ant-select-selection {
  border-radius: 3px !important;
}
.vs-button--icon{
  z-index: 10 !important;
}
.ant-drawer-content-wrapper {
  z-index: 10000 !important;
}
.ant-select-dropdown-menu.ant-select-dropdown-menu-vertical.ant-select-dropdown-menu-root{
  z-index: 200000000 !important;
  position: relative;
}
[dir=ltr] .ant-drawer-mask{
  z-index: 1000 !important;
}
</style>
